/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LaundryGroupRecurringCalendarDay } from './LaundryGroupRecurringCalendarDay';
import {
    LaundryGroupRecurringCalendarDayFromJSON,
    LaundryGroupRecurringCalendarDayFromJSONTyped,
    LaundryGroupRecurringCalendarDayToJSON,
} from './LaundryGroupRecurringCalendarDay';

/**
 * 
 * @export
 * @interface LaundryGroupRecurringCalendar
 */
export interface LaundryGroupRecurringCalendar {
    /**
     * 
     * @type {Array<LaundryGroupRecurringCalendarDay>}
     * @memberof LaundryGroupRecurringCalendar
     */
    days: Array<LaundryGroupRecurringCalendarDay>;
}

/**
 * Check if a given object implements the LaundryGroupRecurringCalendar interface.
 */
export function instanceOfLaundryGroupRecurringCalendar(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "days" in value;

    return isInstance;
}

export function LaundryGroupRecurringCalendarFromJSON(json: any): LaundryGroupRecurringCalendar {
    return LaundryGroupRecurringCalendarFromJSONTyped(json, false);
}

export function LaundryGroupRecurringCalendarFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupRecurringCalendar {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'days': ((json['days'] as Array<any>).map(LaundryGroupRecurringCalendarDayFromJSON)),
    };
}

export function LaundryGroupRecurringCalendarToJSON(value?: LaundryGroupRecurringCalendar | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'days': ((value.days as Array<any>).map(LaundryGroupRecurringCalendarDayToJSON)),
    };
}

